//抽查
import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL
export default {
  /* 配置 */
  //分类枚举
  spotTypeList: (data) => apiAxios('post', baseURL + '/spot/typeList', data),
  //任务要求配置-列表
  expectList: (data) => apiAxios('post', baseURL + '/spot/expect/list', data),
  //任务要求配置-添加
  expectStore: (data) => apiAxios('post', baseURL + '/spot/expect/store', data),
  //任务要求配置-删除
  expectDelete: (data) => apiAxios('post', baseURL + '/spot/expect/delete', data),


  /* 手动任务 */
  //任务-列表tab统计
  listTab: (data) => apiAxios('post', baseURL + '/spot/spot/listTab', data),
  //任务-修改备注
  updateRemark: (data) => apiAxios('post', baseURL + '/spot/spot/updateRemark', data),
  //任务-修改结束时间
  updateEndAt: (data) => apiAxios('post', baseURL + '/spot/spot/updateEndAt', data),

  //任务-列表
  spotList: (data) => apiAxios('post', baseURL + '/spot/spot/list', data),
  //任务-任务-关联赔款单
  addReparation: (data) => apiAxios('post', baseURL + '/spot/spot/addReparation', data),
  //任务-获取一个新单号
  getNewSpotSn: (data) => apiAxios('post', baseURL + '/spot/spot/getNewSpotSn', data),
  //任务-关闭任务
  spotCancel: (data) => apiAxios('post', baseURL + '/spot/spot/cancel', data),
  //任务-确认任务
  spotConfirm: (data) => apiAxios('post', baseURL + '/spot/spot/confirm', data),
  //任务-手动发送通知
  resendNotice: (data) => apiAxios('post', baseURL + '/spot/spot/resendNotice', data),
  //任务-获取可选任务要求
  storeTypeOption: (data) => apiAxios('post', baseURL + '/spot/spot/storeTypeOption', data),
  //任务-到货核查-抽查项目选项
  spotDetailOptionType1: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType1', data),
  //任务-到货核查-新建任务
  storeType1: (data) => apiAxios('post', baseURL + '/spot/spot/storeType1', data),
  //任务-检品抽查-抽查项目选项
  spotDetailOptionType2: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType2', data),
  //任务-检品抽查-新建任务
  storeType2: (data) => apiAxios('post', baseURL + '/spot/spot/storeType2', data),
  //任务-FBA抽查-抽查项目选项
  spotDetailOptionType4: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType4', data),
  //任务-FBA抽查-新建任务
  storeType4: (data) => apiAxios('post', baseURL + '/spot/spot/storeType4', data),
  //任务-在库货物抽查-抽查项目选项
  spotDetailOptionType3: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType3', data),
  //任务-在库货物抽查-新建任务
  storeType3: (data) => apiAxios('post', baseURL + '/spot/spot/storeType3', data),
  //任务-商品退货抽查-抽查项目选项
  spotDetailOptionType10: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType10', data),
  //任务-商品退货抽查-新建任务
  storeType10: (data) => apiAxios('post', baseURL + '/spot/spot/storeType10', data),
  //任务-待出货包裹抽查-抽查项目选项
  spotDetailOptionType7: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType7', data),
  //任务-待出货包裹抽查-新建任务
  storeType7: (data) => apiAxios('post', baseURL + '/spot/spot/storeType7', data),
  //任务-已出货配送单抽查-抽查项目选项
  spotDetailOptionType8: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType8', data),
  //任务-已出货配送单抽查-新建任务
  storeType8: (data) => apiAxios('post', baseURL + '/spot/spot/storeType8', data),
  //任务-出货现场抽查-抽查项目选项
  spotDetailOptionType9: (data) => apiAxios('post', baseURL + '/spot/spot/spotDetailOptionType9', data),
  //任务-出货现场抽查-新建任务
  storeType9: (data) => apiAxios('post', baseURL + '/spot/spot/storeType9', data),



  /* 自动任务配置 */
  //执行人类型枚举
  executeTypeList: (data) => apiAxios('post', baseURL + '/spot/spark/executeTypeList', data),
  //自动任务-配置列表tab
  sparkListTab: (data) => apiAxios('post', baseURL + '/spot/spark/listTab', data),
  //自动任务-配置列表
  sparkList: (data) => apiAxios('post', baseURL + '/spot/spark/list', data),
  //自动任务-添加配置
  sparkStore: (data) => apiAxios('post', baseURL + '/spot/spark/store', data),
  //自动任务-修改配置
  sparkUpdate: (data) => apiAxios('post', baseURL + '/spot/spark/update', data),
  //自动任务-删除配置
  sparkDelete: (data) => apiAxios('post', baseURL + '/spot/spark/delete', data),

  /* 规则*/
  // 条件模型选项参考
  conditionOption: (data) => apiAxios('post', baseURL + '/spot/spark/conditionOption', data),
  // 自动任务--添加规则-到货核查/检品操作
  storeRule: (data) => apiAxios('post', baseURL + '/spot/spark/storeRule', data),
  // 自动任务--修改规则--到货核查/检品操作
  updateRule: (data) => apiAxios('post', baseURL + '/spot/spark/updateRule', data),
  // 自动任务-删除规则
  deleteRule: (data) => apiAxios('post', baseURL + '/spot/spark/deleteRule', data),

  // 订单详情-抽查任务查询
  getSpotOrderDetail: (data) => apiAxios('post', baseURL + '/spot/spot/check/getSpotOrderDetail', data),
  // 配送单详情-抽查任务查询
  getSpotPorderDetail: (data) => apiAxios('post', baseURL + '/spot/spot/check/getSpotPorderDetail', data),
  // 订单详情-抽查任务查询
  getSpotUpstorageDetail: (data) => apiAxios('post', baseURL + '/spot/spot/check/getSpotUpstorageDetail', data),

  // 预设任务列表TAB
  presetListTab: (data) => apiAxios('post', baseURL + '/spot/spot/preset/listTab', data),
  // 预设任务列表
  presetList: (data) => apiAxios('post', baseURL + '/spot/spot/preset/list', data),

  /* 商品信息记录设置 */
  //执行人类型枚举
  executeTypeList: (data) => apiAxios('post', baseURL + '/record/spark/executeTypeList', data),
  //商品信息记录设置-配置列表tab
  recordListTab: (data) => apiAxios('post', baseURL + '/record/spark/listTab', data),
  //商品信息记录设置-配置列表
  recordList: (data) => apiAxios('post', baseURL + '/record/spark/list', data),
  //商品信息记录设置-配置详情
  recordDetail: (data) => apiAxios('post', baseURL + '/record/spark/detail', data),
  //商品信息记录设置-添加配置
  recordStore: (data) => apiAxios('post', baseURL + '/record/spark/store', data),
  //商品信息记录设置-修改配置
  recordUpdate: (data) => apiAxios('post', baseURL + '/record/spark/update', data),
  //商品信息记录设置-删除配置
  recordDelete: (data) => apiAxios('post', baseURL + '/record/spark/delete', data),
  //商品信息记录设置-条件模型选项
  recordConditionOption: (data) => apiAxios('post', baseURL + '/record/spark/conditionOption', data),
  //商品信息记录设置-添加规则
  recordStoreRule: (data) => apiAxios('post', baseURL + '/record/spark/rule/store', data),
  //商品信息记录设置-修改规则
  recordUpdateRule: (data) => apiAxios('post', baseURL + '/record/spark/rule/update', data),
  //商品信息记录设置-删除规则
  recordDeleteRule: (data) => apiAxios('post', baseURL + '/record/spark/rule/delete', data),
  //商品信息记录设置-手动测试触发
  testRun: (data) => apiAxios('post', baseURL + '/record/spark/testRun', data),

  //商品信息任务-任务类型枚举
  taskTypeList: (data) => apiAxios('post', baseURL + '/record/task/taskTypeList', data),
  //商品信息任务-任务列表tab
  taskListTab: (data) => apiAxios('post', baseURL + '/record/task/listTab', data),
  //商品信息任务-任务列表
  taskList: (data) => apiAxios('post', baseURL + '/record/task/list', data),
  //商品信息任务-任务详情
  taskDetail: (data) => apiAxios('post', baseURL + '/record/task/detail', data),
  //商品信息任务-修改执行人
  recordUpdateExecuteBy: (data) => apiAxios('post', baseURL + '/record/task/updateExecuteBy', data),
  //商品信息任务-设置任务备注   
  recordUpdateRemark: (data) => apiAxios('post', baseURL + '/record/task/updateRemark', data),
  //商品信息任务-取消任务
  recordCloseTask: (data) => apiAxios('post', baseURL + '/record/task/close', data),
  //商品信息任务-再次推送任务提醒
  recordRemindTask: (data) => apiAxios('post', baseURL + '/record/task/remind', data),

  //商品信息任务-业务录入预览(操作时长)
  businessPreview: (data) => apiAxios('post', baseURL + '/record/entry/businessPreview', data),
  //商品信息任务-业务录入保存(操作时长)
  businessSave: (data) => apiAxios('post', baseURL + '/record/entry/businessSave', data),
  //商品信息任务-配货录入预览(尺寸/重量)
  deliveryPreview: (data) => apiAxios('post', baseURL + '/record/entry/deliveryPreview', data),
  //商品信息任务-配货录入保存(尺寸/重量)
  deliverySave: (data) => apiAxios('post', baseURL + '/record/entry/deliverySave', data),
}